import AudioManager from "scripts/util/AudioManager";
import * as BABYLON from "babylonjs";
import Main from "scripts/3d/experience/Main";

class Boost {
  constructor(rootMesh, index, anims) {
    this.view = new BABYLON.TransformNode("Boost" + index + "_Transform");
    this.view.rotationQuaternion = null;

    this.logo = new BABYLON.TransformNode("Boost" + index + "_Logo");
    this.logo.parent = this.view;
    this.logo.position.y +=.68;

    this.chevron = new BABYLON.TransformNode("Boost" + index + "_Chevron");
    this.chevron.parent = this.view;

    const dupe = rootMesh.clone("BOOST-" + index);
    //dupe.parent = this.view;
    const children = dupe.getChildMeshes();
    children.forEach((child, i) => {
      child.isVisible = true;
      console.log("CHILDNAME:", child.name);
      // if (child.name === "BOOST-" + index + ".Innder Cirk.001") 
      if (child.name.includes("Innder")) 
        child.parent = this.logo;
      
      if (child.name === "BOOST-" + index + ".chevron") 
      {
        //child.rotation.y = Math.PI/3;
        console.log("CHEVRON FOUND");
        child.parent = this.chevron;
        this.chevron.rotation.y = Math.PI;
      }
    });
    
    const dupeAnim = anims["Rotation_5G"].clone();
    //Animation cloning
    let animGroupClone = new BABYLON.AnimationGroup("BoostAnimations" + index);
    animGroupClone.addTargetedAnimation(
      dupeAnim.targetedAnimations[0].animation,
      this.logo
    );
    animGroupClone.play();
    animGroupClone.onAnimationGroupEndObservable.add(function () {
      animGroupClone.play();
    });
    dupeAnim.dispose();

    // const children = rootMesh.getChildMeshes();
    // children.forEach((child, i) => {
    //   // if (child.name.includes("5G")) {
    //   //   const newMesh = child.createInstance("Boost" + index + child.name);
    //   //   newMesh.parent = this.logo;
    //   // }
    //   // if(child.name === 'chevron') {
    //   //   const chevron = child.createInstance('BoostChevron')
    //   //   cheveron.parent = this.view
    //   // }
    //   // else {
    //   //   const dupe = child.createInstance(child.name)
    //   //   child.parent = this.view;
    //   // }

    //   const dupe = child.createInstance(child.name);
    //   dupe.parent = this.view;
    // });

    this.isHit = false;

    this.collider = BABYLON.MeshBuilder.CreateBox(
      "BOOST-" + index + "-Collider",
      { width: 1.5, size: 1.2 }
    );
    this.collider.position.y = 0.4;
    this.collider.parent = this.view;
    this.collider.isVisible = false;
  }

  setConfig(config) {
    this.config = config;
    const { position, rotation, scaling } = this.config;
    this.view.rotation = rotation;
    this.view.position = position;
    this.view.scaling = scaling;
  }

  hit() {
    this.isHit = true;
    this.logo.getChildMeshes().forEach((mesh) => (mesh.isVisible = false));
    AudioManager.playSound("boost");
    Main.VFX.boostOn();
  }

  reset() {
    this.isHit = false;
    this.logo.getChildMeshes().forEach((mesh) => (mesh.isVisible = true));
    Main.VFX.boostOff();
  }

  destroy() {
    this.collider.parent = null;
    this.collider.isVisible = false;
    this.collider.dispose();

    this.view.parent = null;
    this.view.isVisible = false;
    this.view.dispose();
  }
}

export default Boost;
